import { handleActions } from 'redux-actions';
import {
    formFinderConfigLoaded,
    formFinderConfigUnload,
    finderChangeStep,
    finderUpdatedSections,
    finderUpdateName,
    formFinderSaved,
} from '../actions';

const initialState = {
    formFinder: {
        name: '',
    },
    lastSavedFinder: {},
    steps: [],
    activeStep: -1,
    forms: [],
    savedSuccess: false,
};

export default handleActions(
    {
        [formFinderConfigLoaded]: (state, action) => {
            return {
                ...state,
                ...action.payload,
            };
        },
        [finderChangeStep]: (state, action) => ({
            ...state,
            activeStep: action.payload,
        }),
        [finderUpdateName]: (state, action) => ({
            ...state,
            formFinder: {
                ...state.formFinder,
                name: action.payload,
            },
        }),
        [finderUpdatedSections]: (state, action) => {
            return {
                ...state,
                steps: action.payload,
            };
        },
        [formFinderSaved]: (state, action) => ({
            ...state,
            lastSavedFinder: action.payload,
            formFinder: action.payload,
        }),
        [formFinderConfigUnload]: () => initialState,
    },
    initialState,
);
